import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IUserProfileStore } from '../interfaces/user-profile-store.interface';

export const selectUserProfile = (state: IAppState) => state.userProfile;

export const selectUserProfileId = createSelector(
  selectUserProfile,
  (userProfile: IUserProfileStore) => ({
    userProfileId: userProfile.userProfileId,
  }),
);

export const selectAllUserProfile = createSelector(
  selectUserProfile,
  (userProfile: IUserProfileStore) => ({
    name: userProfile.name,
    userProfileId: userProfile.userProfileId,
  }),
);
